export default "__VITE_ASSET__e70610cb__"